import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/010-upload.png';
const _withScopeId = n => (_pushScopeId("data-v-ed9ac30a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "single main"
};
const _hoisted_2 = {
  key: 0,
  class: "upload-img-show"
};
const _hoisted_3 = {
  class: "box"
};
const _hoisted_4 = {
  class: "upload-logo-div"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "upload-icon upload-icon1",
  src: _imports_0
}, null, -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "el-upload__text upload-icon-text"
}, [/*#__PURE__*/_createTextVNode("将图片拖拽至此，或 "), /*#__PURE__*/_createElementVNode("em", null, "点击上传")], -1));
const _hoisted_7 = {
  class: "slider-container"
};
const _hoisted_8 = {
  class: "slider-value"
};
const _hoisted_9 = {
  class: "slider-container"
};
const _hoisted_10 = {
  class: "slider-value"
};
const _hoisted_11 = {
  class: "slider-container"
};
const _hoisted_12 = {
  class: "slider-value"
};
const _hoisted_13 = {
  class: "action-buttons"
};
const _hoisted_14 = {
  class: "img-nav"
};
const _hoisted_15 = {
  class: "img-box-r"
};
const _hoisted_16 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_upload = _resolveComponent("el-upload");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_slider = _resolveComponent("el-slider");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_form = _resolveComponent("el-form");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [$data.dialogVisible ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
    class: _normalizeClass(["form-box-box", {
      'form-box-box-show': $data.zkShow
    }])
  }, [!$data.zkShow ? (_openBlock(), _createBlock(_component_el_form, {
    key: 0,
    class: "form-box"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_form_item, {
      class: "form-box-item-up",
      label: "上传调整图片",
      "label-position": "top"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_upload, {
        class: "upload",
        drag: "",
        action: "#",
        "list-type": "picture-card",
        "auto-upload": false,
        "on-success": $options.onSuccess2,
        "on-change": $options.onChange,
        "show-file-list": false
      }, {
        default: _withCtx(() => [_hoisted_5, _hoisted_6]),
        _: 1
      }, 8, ["on-success", "on-change"])])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      class: "item-item-item",
      label: "等比例调大小",
      "label-position": "top"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_7, [_createVNode(_component_el_slider, {
        modelValue: $data.logoStyle.scale,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.logoStyle.scale = $event),
        class: "slider-width",
        "show-input": "",
        size: "small",
        "show-stops": "",
        step: 0.01,
        min: 0.00001,
        max: "30"
      }, null, 8, ["modelValue"]), _createElementVNode("div", _hoisted_8, _toDisplayString(($data.logoStyle.scale * 100).toFixed(0)) + "%", 1)])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      class: "item-item-item",
      label: "图片宽度",
      "label-position": "top"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_9, [_createVNode(_component_el_slider, {
        modelValue: $data.logoStyle.imgwidth,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.logoStyle.imgwidth = $event),
        class: "slider-width",
        "show-input": "",
        size: "small",
        "show-stops": "",
        step: 5,
        min: 1,
        max: "3000"
      }, null, 8, ["modelValue"]), _createElementVNode("div", _hoisted_10, _toDisplayString($data.logoStyle.imgwidth) + "px", 1)])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      class: "item-item-item",
      label: "图片高度",
      "label-position": "top"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_11, [_createVNode(_component_el_slider, {
        modelValue: $data.logoStyle.imgheight,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.logoStyle.imgheight = $event),
        class: "slider-width",
        "show-input": "",
        size: "small",
        "show-stops": "",
        step: 2,
        min: 1,
        max: "3000"
      }, null, 8, ["modelValue"]), _createElementVNode("div", _hoisted_12, _toDisplayString($data.logoStyle.imgheight) + "px", 1)])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      class: "item-item-item item-item-item-1"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_13, [_createVNode(_component_el_button, {
        class: "download-btn",
        type: "primary",
        onClick: $options.downloadAll,
        disabled: _ctx.disabledBtn
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($data.downloadTxt), 1)]),
        _: 1
      }, 8, ["onClick", "disabled"]), _createVNode(_component_el_button, {
        class: "close-btn",
        onClick: _cache[3] || (_cache[3] = $event => $data.dialogVisible = false)
      }, {
        default: _withCtx(() => [_createTextVNode(" 关闭 ")]),
        _: 1
      })])]),
      _: 1
    })]),
    _: 1
  })) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_14, [_createElementVNode("span", {
    class: "img-nav-span",
    onClick: _cache[4] || (_cache[4] = $event => $data.zkShow = !$data.zkShow)
  }, _toDisplayString($data.zkShow ? '展开' : '收起'), 1)])], 2), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", {
    class: "img-box-logo",
    style: _normalizeStyle(`
              height: ${$data.h};
              width: ${$data.w};
              background-color: ${$data.logoStyle.bg};
            `),
    ref: "imgBoxLogo"
  }, [_createElementVNode("img", {
    ref: "logoSpan",
    class: "el-upload-list__item-thumbnail img-img",
    style: _normalizeStyle(`
                width: ${$data.logoStyle.imgwidth}px;
                height: ${$data.logoStyle.imgheight}px;
                opacity: ${$data.logoStyle.opacity};
                transform: rotate(${$data.logoStyle.rotate}deg) scale(${$data.logoStyle.scale});
                border-radius: ${$data.logoStyle.borderRadius}px;
                background-color: ${$data.logoStyle.bg};
              `),
    src: $data.logoStyle.logoImg
  }, null, 12, _hoisted_16)], 4)])])])) : _createCommentVNode("", true)]);
}